<template>
  <div style="width: 150px;">
    <Input @on-clear="clear" v-model="nameHand" :clearable="clearable" :readonly='!isHand'>
    <Button slot="append" icon="md-person" @click="openUser = true"> </Button></Input>

    <Drawer :placement="placement" :closable="false" v-model="openUser" draggable class="my-drawer" width="300">
      <userTree :more="more" :keyword="keyword" @user="reUser" @users="reUsers"></userTree>
    </Drawer>
  </div>
</template>
<script>
export default {
  props: ["name", "placement", "keyword", "isHand", "clearable", "more"],
  data() {
    return {
      openUser: false,
      nameHand: "",
      nameHand: ''
    };
  },
  methods: {
    reUser(v) {

      if (!this.more) {
        this.name=v.name;
        this.openUser = false;
        this.$emit("update:id", v.id);
        this.$emit("update:account", v.account);
        this.$emit("update:accountId", v.accountId);
        this.$emit("update:name", v.name);
        this.$emit("user", v);
      }

    },
    clear() {
      this.$emit("update:id", "");
      this.$emit("update:account", "");
      this.$emit("update:accountId", "");
      this.$emit("update:name", "");
    },
    reUsers(v) {
      var ids = [], accounts = [], names = [];
      for (let i = 0; i < v.length; i++) {
        ids.push(v[i].accountId);
        names.push(v[i].name);
        accounts.push(v[i].account);
      }
      this.$emit('accountIds', ids);
      this.$emit('accounts', accounts);
      this.$emit('names', names);
      this.nameHand = this.text(names);
      console.log(this.nameHand);
    },
    text(t) {
      
      if (t.length == 1) {
        return t[0]
      } else {
        return '选择了' + t.length + "个"
      }
    },
  },
  watch: {
    name(v) {
      this.nameHand = v;
    },
    nameHand(v) {
      this.$emit("update:name", v);
    },
    

  },
  mounted() {
    this.nameHand = this.name;
  },
};
</script>



// WEBPACK FOOTER //
// src/components/common/selectUser.vue